import React from 'react';
import {Box, Container, Typography} from '@mui/material';

export const NotAuthenticatedPage = () => {

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    textAlign: 'center',
                    mt: 12,
                    p: 4,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',
                }}
            >
                <Typography variant="h4" color="error" gutterBottom>
                    Access Denied
                </Typography>
            </Box>
        </Container>
    );
}
